import * as React from 'react'
import { cls } from '@utils/classnames'

export interface CountryLanguageSwitcher {
  id: string
  countrySwitchLabel: string
  searchPlaceholder: string
  hideSearch?: boolean
  navigationCountryAndLanguageLabel?: string
  /** currently active country - to match with title */
  countryPageLabel: string
  items: CountryLanguageCountry[]
}

interface CountryLanguageCountry {
  title: string
  languages: SwitcherNode[]
}

interface SwitcherNode {
  link: {
    externalizedURL: string
  }
  /** to be displayed */
  title: string
  /** currently active page */
  active: boolean
}

const LanguageSwitcherCountry: React.FC<{
  countryNode: CountryLanguageCountry
  countryPageLabel: string
}> = ({ countryNode, countryPageLabel }) => {
  const isCountrySelected = countryNode.title === countryPageLabel
  const countryLanguages = countryNode.title.split('/')?.map((language) => language.trim()) || []

  return (
    <li
      className={cls({
        'language-switcher__country': true,
        'language-switcher__country--active': isCountrySelected,
      })}
    >
      <h3 className="language-switcher__country-name">{countryNode.title}</h3>
      <ul className="language-switcher__language-list">
        {countryNode.languages.map((languageNode, index) => (
          <li key={languageNode.title}>
            <a
              href={languageNode.link.externalizedURL}
              aria-label={`${languageNode.title}, ${countryLanguages[index]}`}
              aria-current={languageNode.active ? 'page' : undefined}
              className={cls({
                'language-switcher__country-language': true,
                'language-switcher__country-language--active': languageNode.active,
              })}
            >
              {languageNode.title}
            </a>
          </li>
        ))}
      </ul>
    </li>
  )
}

export default React.memo(LanguageSwitcherCountry)
